export default __webpack_public_path__ + "6ab4e95ab4d4603a8758f96d20c4fa75.jpg";